import React from 'react';
import { LogoContainer } from 'src/domains/layouts/webview/components/logoContainer/LogoContainer';
import { LogoGroup } from 'src/domains/layouts/webview/components/logoContainer/LogoContainer.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import {
    LogoGambleAwareV2Wrapper,
    LogoGamblingHelplineWrapper,
    SecondaryLinksContainer,
    SecondaryLink,
    VerticalDivider,
} from 'src/domains/players/webview/components/Account/responsibleGamblingLinks/responsibleGamblingLinks.style';
import { observer } from 'src/utils/mobx-react';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    type: 'primary' | 'secondary';
    isSignup?: boolean;
}

export const ResponsibleGamblingLinks = observer(
    'ResponsibleGamblingLinks',
    ({ type, isSignup = false }: PropsType): JSX.Element => {
        const common = useCommon();
        const configComponents = ConfigComponents.get(common);
        const accountHelperMail = configComponents.config.accountHelperMail;

        if (type === 'primary') {
            return (
                <LogoGroup>
                    <LogoContainer
                        to='https://www.gambleaware.org/'
                        type={isSignup ? 'secondary' : type}
                        dataTest='gamble-aware-logo'
                    >
                        <LogoGambleAwareV2Wrapper />
                    </LogoContainer>
                    <LogoContainer
                        to='https://www.gamcare.org.uk/get-support/talk-to-us-now/'
                        type={isSignup ? 'secondary' : type}
                        dataTest='gamcare-logo'
                    >
                        <LogoGamblingHelplineWrapper />
                    </LogoContainer>
                </LogoGroup>
            );
        }

        return (
            <SecondaryLinksContainer>
                <SecondaryLink
                    to={{ account: 'static', static: 'safer-gambling' }}
                    routeNameForGtm='safer-gambling'
                >
                    <I18n
                        langKey='account.footer.safer-gambling'
                        defaultText='Safer Gambling'
                    />
                </SecondaryLink>
                <VerticalDivider />
                <SecondaryLink
                    to={`mailto:${accountHelperMail}`}
                    routeNameForGtm='contact-us'
                >
                    <I18n
                        langKey='account.footer.contact-us.email'
                        defaultText='Contact Us'
                        params={{ accountHelperMail }}
                    />
                </SecondaryLink>
                <VerticalDivider />
                <SecondaryLink
                    to={{ account: 'static', static: 'privacy-policy' }}
                    routeNameForGtm='privacy-policy'
                >
                    <I18n
                        langKey='account.footer.privacy-policy'
                        defaultText='Privacy Policy'
                    />
                </SecondaryLink>
            </SecondaryLinksContainer>
        );
    }
);
